import { defineMessages } from 'react-intl';

import { HorizontalDivider } from '#src/atoms/ui/Divider/index.tsx';
import { PhoneNumberVerificationSection } from '#src/components/settings/PhoneNumberVerification/PhoneNumberVerificationSection/index.tsx';
import { RecoveryEmail } from '#src/components/settings/RecoveryEmail/index.tsx';
import { SettingsSection } from '#src/components/settings/SettingsSection/index.tsx';
import { UpdateEmail } from '#src/components/settings/UpdateEmail/index.tsx';
import { UpdateName } from '#src/components/settings/UpdateName/index.tsx';
import { useCurrentUserContext } from '#src/contexts/currentUser/index.ts';

const messages = defineMessages({
  title: {
    defaultMessage: 'Personal Info',
  },
});

export const PersonalInfo = () => {
  const { currentUser } = useCurrentUserContext();
  return (
    <SettingsSection {...messages}>
      <UpdateName />
      <UpdateEmail />
      <HorizontalDivider />
      <RecoveryEmail />
      {!!currentUser && (
        <>
          <HorizontalDivider />
          <PhoneNumberVerificationSection />
        </>
      )}
    </SettingsSection>
  );
};
